const _ = require('lodash');

const sepaCountries = [
  'AT', 'BE', 'BG', 'CH',
  'CY', 'CZ', 'DK', 'DE',
  'EE', 'ES', 'FI', 'FO',
  'FR', 'GB', 'GI', 'GR',
  'GL', 'HR', 'HU', 'IE',
  'IS', 'IT', 'LI', 'LT',
  'LU', 'LV', 'MC', 'MT',
  'NL', 'NO', 'PL', 'PT',
  'RO', 'SE', 'SI', 'SK',
  'SM'
]

module.exports = value => {
  const countryCode = value.slice(0, 2);
  return sepaCountries.includes(countryCode);
};
